export const WHITE_COLOR = "#fff";
export const DARK_ORANGE_COLOR = "#F37335";
export const ORANGE_COLOR = "#FDC830";
export const DARK_GRAY_COLOR = "#333333"